import User from '../models/User.js'

export const RegisterMixin = {
  data() {
    return {
      user: this.initialize(),
    }
  },
  methods: {
    initialize() {
      return new User({
        email: '',
        password: '',
        country_id: undefined,
        activation_code: null,
        referral_code: '',
        recaptcha: '',
        force: false
      })
    }
  }
}
